import { ResponsiveBlockSwitcher } from "@/shared/Components";
import type { ContactsTabsProps } from "../model";
import { ContactTabsContentDesktop } from "./components/desktop";

export const ContactTabsContent = ({
  selectedPersonId,
  setSelectedPersonId,
}: ContactsTabsProps) => {
  return (
    <ResponsiveBlockSwitcher
      desktop={
        <ContactTabsContentDesktop
          selectedPersonId={selectedPersonId}
          setSelectedPersonId={setSelectedPersonId}
        />
      }
      mobile={<div>ContactTabsContentMobile</div>}
    />
  );
};
